import { render, staticRenderFns } from "./golongantabungan.vue?vue&type=template&id=c4c6af94&scoped=true"
import script from "./golongantabungan.vue?vue&type=script&lang=js"
export * from "./golongantabungan.vue?vue&type=script&lang=js"
import style0 from "./golongantabungan.vue?vue&type=style&index=0&id=c4c6af94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c6af94",
  null
  
)

export default component.exports